import React from "react";
// Custom Select

// Mui
import Typography from "@mui/material/Typography";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { SxProps, Theme } from "@mui/material/styles";

// Types
interface SelectOption {
  type: string;
  value?: string | number;
  [key: string]: any;
}

interface CustomSelectProps {
  value: SelectOption | string;
  onChange: (event: SelectChangeEvent<SelectOption | string>) => void;
  icon?: React.ElementType;
  title: string;
  options: SelectOption[];
  titleSx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  showSelected?: boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  value,
  onChange,
  icon,
  title,
  options,
  titleSx,
  iconSx,
  showSelected = true,
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      displayEmpty
      IconComponent={icon}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px 0px #0000001A",
            border: "1px solid #B0B6BE",
            padding: "4px",
          },
        },
      }}
      sx={{
        border: "none",
        background: "transparent",
        boxShadow: "none",
        padding: 0,
        marginTop: "8px",
        ".MuiSelect-select": {
          padding: "4px",
        },
        ".MuiOutlinedInput-notchedOutline": {
          border: "none !important",
        },
        ".MuiSelect-icon": iconSx as any,
      }}
      renderValue={(selected) =>
        showSelected ? (
          selected && typeof selected === "object" && "type" in selected ? (
            <Typography variant="body2" sx={titleSx}>
              {(selected as SelectOption).type}
            </Typography>
          ) : (
            <Typography variant="body2" sx={titleSx}>
              {title}
            </Typography>
          )
        ) : (
          <Typography variant="body2" sx={titleSx}>
            {title}
          </Typography>
        )
      }>
      {options?.map((option, idx) => (
        <MenuItem
          key={idx}
          value={option as any}
          sx={{
            fontSize: "11px",
            fontWeight: 400,
            lineHeight: "17px",
            textAlign: "left",
            color: "#181B25",
            mt: "4px",
            "&:hover": {
              backgroundColor: "#DEEBF4",
            },
            "&.Mui-selected": {
              backgroundColor: "#DEEBF4",
            },
          }}>
          {option.type}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
